const config = {
  //FOR PROD
  // gevmeEndPoint: "https://www.gevme.com/apiv2"

  //FOR STAGING
  gevmeEndPoint: process.env.gevmeEndPoint,
  gevmeUrl: process.env.gevmeUrl,
  redirectionBaseUrl: process.env.redirectionBaseUrl
};
export default config;



// WEBPACK FOOTER //
// ./src/config/config.js